import sticky from './sticky'

export default function create(app) {
    app.directive('sticky', sticky)
}